import { createApi } from "element-plus-admin/utils/create-api";
import { useAuth } from "@/composables/use-auth";

export const examQuestionsApi = createApi({
  url: "/admin/examQuestions",
  headers: useAuth().getHeaders,
});
